<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="titulo-con-guia">
          <p class="title">{{ esAdmin ? t("Clientes", "Customers") : t("Mis clientes", "My customers") }}</p>
          <GuiaRecorrido v-if="!noEsPromotor" ref="guia" id="qr-mis-clientes" :pasos="pasosGuia" />
        </div>
        <p class="subtitle is-6">
          {{ esAdmin ? t("Las compras de todos los promotores. Filtra por promotor para ver los de cada uno.", "Purchases from all promoters. Filter by promoter to see each one's.") : t("Las compras que entraron por tu QR.", "Purchases made through your QR.") }}
        </p>
      </div>
    </section>

    <!-- El admin ve los clientes de todos los promotores; cada promotor, solo los suyos -->
    <VentasQr v-if="esAdmin" sin-titulo />

    <template v-else>
    <b-message v-if="noEsPromotor" type="is-warning">
      {{ t("Tu usuario todavía no está dado de alta como promotor. Pídele a un administrador que te agregue en Cobro QR → Promotores.", "Your user is not set up as a promoter yet. Ask an administrator to add you in QR Payments → Promoters.") }}
    </b-message>

    <div v-else class="box mi-qr" data-guia="m-qr">
      <b-loading :is-full-page="false" :active="cargandoQr"></b-loading>
      <img v-if="imagen" :src="imagen" alt="QR" />
      <div>
        <p class="is-size-5"><b>{{ t("Tu QR de cobro", "Your payment QR") }}</b></p>
        <p class="is-size-7 mb-2">
          <a v-if="promotor" :href="promotor.Url" target="_blank" rel="noopener">{{ promotor.Url }}</a>
        </p>
        <b-tag v-if="promotor && !promotor.Activo" type="is-danger is-light" class="mb-2">{{ t("Desactivado: tu QR no está recibiendo pagos", "Disabled: your QR is not taking payments") }}</b-tag>
        <div class="buttons" data-guia="m-botones">
          <b-button size="is-small" icon-left="download" icon-pack="fas" @click="bajar('png')">PNG</b-button>
          <b-button size="is-small" icon-left="print" icon-pack="fas" @click="bajar('svg')">{{ t("SVG (imprimir)", "SVG (print)") }}</b-button>
          <b-button size="is-small" icon-left="copy" icon-pack="fas" @click="copiar">{{ t("Copiar link", "Copy link") }}</b-button>
        </div>
      </div>
    </div>

    <VentasQr v-if="!noEsPromotor" propio />
    </template>
  </div>
</template>

<script>
import apiQr, { mensajeError, descargar, imagenBlob } from "../../utils/apiQr";
import VentasQr from "./VentasQr.vue";
import GuiaRecorrido from "../../components/GuiaRecorrido.vue";
import { pasosMisClientes } from "./guiaQr";

export default {
  name: "MisClientesQr",
  components: { VentasQr, GuiaRecorrido },
  data() {
    return {
      iso: localStorage.getItem("iso") || "es",
      // Mismo criterio que el resto del backoffice (checkPermission): admin y ultrauser ven todo
      esAdmin: ["admin", "ultrauser"].includes(localStorage.getItem("role")),
      promotor: null,
      imagen: null,
      cargandoQr: false,
      noEsPromotor: false,
    };
  },
  computed: {
    pasosGuia() {
      return pasosMisClientes(this.t, { esAdmin: this.esAdmin });
    },
  },
  async created() {
    this.$bus.on("change-iso", () => (this.iso = localStorage.getItem("iso")));
    if (this.esAdmin) return this.abrirGuia();
    try {
      this.cargandoQr = true;
      this.promotor = (await apiQr.get("/promotores/mio")).data;
      this.imagen = await imagenBlob("/promotores/mio/qr");
    } catch (error) {
      if (error?.response?.status === 404) this.noEsPromotor = true;
      else this.$buefy.toast.open({ message: mensajeError(error), type: "is-danger" });
    } finally {
      this.cargandoQr = false;
    }
    this.abrirGuia();
  },
  beforeDestroy() {
    if (this.imagen) URL.revokeObjectURL(this.imagen);
  },
  methods: {
    // La guía se abre sola la primera vez; espera un momento a que la lista de ventas termine de pintarse
    abrirGuia() {
      setTimeout(() => this.$refs.guia && this.$refs.guia.autoIniciar(), 800);
    },
    t(es, en) {
      return this.iso === "es" ? es : en;
    },
    async bajar(formato) {
      try {
        await descargar("/promotores/mio/qr", `mi-qr.${formato}`, formato === "svg" ? { formato: "svg" } : {});
      } catch (error) {
        this.$buefy.toast.open({ message: mensajeError(error), type: "is-danger" });
      }
    },
    async copiar() {
      try {
        await navigator.clipboard.writeText(this.promotor.Url);
        this.$buefy.toast.open({ message: this.t("Link copiado", "Link copied"), type: "is-success" });
      } catch (e) {
        this.$buefy.toast.open({ message: this.promotor.Url, type: "is-info", duration: 6000 });
      }
    },
  },
};
</script>

<style scoped>
.mi-qr {
  display: flex;
  gap: 1.2rem;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
}
.mi-qr img {
  width: 150px;
  height: 150px;
}
</style>
